module.exports = __webpack_public_path__ + "static/assets/ec74b9cfe2c97cd27615309293e8708e.png";